<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>{{ !this.edit ? "New" : "Edit" }} Area of Interest</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngAreaForm" #ngForm="ngForm" id="areaForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>
                  <label
                    style="width: auto; min-width: auto;"
                    class="mt-1 mb-1"
                    for="">Name</label>
                  <input
                    style="width: 100%; min-width: 100%;"
                    class="mb-1"
                    required
                    maxlength="100"
                    [(ngModel)]="model.name"
                    type="string"
                    name="name"
                    id="name"
                  />
                </div>
                <div>
                  <label
                    style="width: auto; min-width: auto;"
                    class="mt-1 mb-1"
                    for="">Description</label>
                  <textarea
                    class="mb-1"
                    maxlength="4000"
                    [(ngModel)]="model.description"
                    type="string"
                    name="description"
                    id="description">
                  </textarea>
                </div>
                <div style="margin-top: 5px;">
                  <input
                  type="checkbox"
                  id="defaultArea"
                  name="defaultArea"
                  [(ngModel)]="model.defaultArea"
                  [checked]="model.defaultArea"/>
                <label for="">Default Area</label>
                </div>
              </div>
            </div>
            <div class="fields__block__section" *ngIf="this.edit">
              <div class="title">
                <h4>Update bounds from map</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div style="margin-top: 5px;">
                  <input
                  type="checkbox"
                  id="updateBounds"
                  name="updateBounds"
                  [(ngModel)]="model.updateBounds"
                  [checked]="model.updateBounds" />
                <label for="">Update Bounds</label>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="createArea();" [disabled]="!ngForm.form.valid">
              <span *ngIf="!edit">Create</span>
              <span *ngIf="edit">Edit</span>
            </button>
            <button class="gray" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
